export enum ProviderType {
    PULL = "PULL",
    PUSH = "PUSH"
}